// ExclusiveRevisionTooltipHintHandler.jsx
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { NULL_FUNCTION } from '../resource/defaults.js';

/**
 * Opens the one-off exclusive-revision hint on the first visit to the livestream detail page
 * @param {object} params
 * @param {boolean} [params.shouldDisplayExclusiveRevisionTooltip] - Whether the hint hasn't been shown yet on this device.
 * @param {function} [params.markExclusiveRevisionTooltipSeen] - Persists that the hint has been shown.
 * @param {function} [params.openModal] - Opens the hint modal.
 * @returns {null} Renders nothing.
 */
export const ExclusiveRevisionTooltipHintHandler = ({
  shouldDisplayExclusiveRevisionTooltip = false,
  markExclusiveRevisionTooltipSeen = NULL_FUNCTION,
  openModal = NULL_FUNCTION,
}) => {
  useEffect(() => {
    if (!shouldDisplayExclusiveRevisionTooltip) {
      return;
    }
    // Mark seen the moment we decide to open it, so it only shows once.
    markExclusiveRevisionTooltipSeen();
    openModal();
  }, [
    shouldDisplayExclusiveRevisionTooltip,
    markExclusiveRevisionTooltipSeen,
    openModal,
  ]);

  return null;
};

ExclusiveRevisionTooltipHintHandler.propTypes = {
  shouldDisplayExclusiveRevisionTooltip: PropTypes.bool,
  markExclusiveRevisionTooltipSeen: PropTypes.func,
  openModal: PropTypes.func,
};

export default ExclusiveRevisionTooltipHintHandler;
